module.exports = __webpack_public_path__ + "static/img/ic_check_on@2x.2905701.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_check_on@2x.png
// module id = mXOC
// module chunks = 1